import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { GAWidgetTexts } from "app/pages/activation/components/GAWidget/texts";

import { dataAutomation } from "./dataAutomation";
import { GAButtonContainer, StyledButton, StyledIcon } from "./styles";

type GAButtonSchema = {
    onClick: () => void;
    isViewerMode?: boolean;
};

const ActivateConnectionButton = ({ onClick, isViewerMode }: GAButtonSchema) => (
    <Tooltip
        content={translate(GAWidgetTexts.ownerNotConnectedData)}
        enabled={isViewerMode}
    >
        <GAButtonContainer data-automation={dataAutomation.container}>
            <StyledButton
                data-automation={dataAutomation.btn}
                type="primary"
                label={translate(GAWidgetTexts.activateFirstPartyData)}
                onClick={onClick}
                isDisabled={isViewerMode}
            />

            <StyledIcon
                iconName="arrow-right"
                size="xs"
                iconColor={colorsPalettes.carbon[0]}
            />
        </GAButtonContainer>
    </Tooltip>
);

export default ActivateConnectionButton;
